import { environment } from "../../config";
import {
  DeletedAsignaturas,
  AsignaturaFields,
  iDataAsignatura,
} from "../../interfaces/SuperAdmin/Pages/iDataAsignatura";

import { fetchData } from "./httpClient";

const { REACT_APP_API_OAS } = environment;
const baseApiBroker = REACT_APP_API_OAS;

export const getAsignaturasByOrgId = (id_organizacion: string) =>
  fetchData<iDataAsignatura[]>({
    method: "GET",
    url: `${baseApiBroker}/asignatura/organizacion/${id_organizacion}`,
  });

export const getAsignaturaById = (id_asignatura: string) =>
  fetchData<iDataAsignatura>({
    method: "GET",
    url: `${baseApiBroker}/asignatura/${id_asignatura}`,
  });

export const deleteAsignaturas = (data: { ids: string[] }) =>
  fetchData<DeletedAsignaturas>({
    method: "DELETE",
    url: `${baseApiBroker}/asignatura`,
    data,
  });

export const putAsignaturaById = (
  data: AsignaturaFields,
  id_asignatura: string
) =>
  fetchData<iDataAsignatura>({
    method: "PUT",
    url: `${baseApiBroker}/asignatura/${id_asignatura}`,
    data,
  });

export const postAsignatura = (
  data: AsignaturaFields,
  id_organizacion: string
) =>
  fetchData<iDataAsignatura>({
    method: "POST",
    url: `${baseApiBroker}/asignatura/organizacion/${id_organizacion}`,
    data,
  });
